import { datadogRum } from '@datadog/browser-rum';
import { telemetryUserAttributes, addAppSpecificData } from '@/utilities/analytics';

export const actions = {
  log({ rootState }, message) {
    if (import.meta.env.DEV && rootState.devTools.analyticsLoggingEnabled) {
      window.console.info(`Analytics - EVENT: ${message}`);
    }
  },
  noticeError({ dispatch }, { error, customAttributes = {} }) {
    const errorMessage = error.message || 'NO MESSAGE';
    dispatch('log', `Error Noticed - MESSAGE: ${errorMessage}, DATA: ${JSON.stringify(customAttributes)}`);
    if (import.meta.env.VITE_THIRD_PARTY_JS_ENABLED === 'true') {
      datadogRum.addError(error, customAttributes);
    }
  },
  track({ dispatch, rootGetters }, { title, data }) {
    // eslint-disable-next-line camelcase
    const userId = data?.userId || data?.user_id
    || telemetryUserAttributes(rootGetters.currentUser)?.user_id;
    const compiledData = {
      user_id: userId,
      ...data,
    };

    dispatch('log', `${title}, DATA: ${JSON.stringify(compiledData)}`);
    dispatch('trackMixPanel', { title, compiledData });
    dispatch('trackDatadog', title, compiledData);
  },
  trackDatadog(_context, { title, data }) {
    if (import.meta.env.VITE_THIRD_PARTY_JS_ENABLED === 'true') {
      const localData = addAppSpecificData(data);
      datadogRum.addAction(title, localData);
    }
  },
  trackMixPanel(_context, { title, compiledData = {} }) {
    const localData = addAppSpecificData(compiledData);
    if (window.mixpanel) {
      window.mixpanel.track(title, localData);
    }
  },
};

export default {
  namespaced: true,
  actions,
};
